/**
 * @fileoverview Page constants for Click&Pledge navigation.
 * Defines all page identifiers used for state-based navigation throughout the application.
 */

/**
 * Page constants for state-based navigation in the Click&Pledge flow.
 * Used to manage which page/component should be displayed.
 */
export const PAGES = {
    /** Loading page identifier */
    LOADING: 'loading',

    /** Host landing page identifier */
    HOST: 'host',

    /** Auto-registration page identifier */
    AUTO_REGISTER: 'autoregister',

    /** Publish form page identifier */
    PUBLISH_FORM: 'publishform',

    /** Load form page identifier */
    LOAD_FORM: 'loadform',

    /** Success page identifier */
    SUCCESS: 'success',

    /** Streamer page identifier */
    STREAMER: 'streamer',

    /** Payment iframe page identifier */
    PAYMENT_IFRAME: 'payment_iframe'
};
